/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import React from "react";
import Title from "../../extras/Title";
import Searching from "../../extras/Searching";
import { getAllBookings } from "../../../redux/slice/bookingSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";

import male from "../../../assets/images/male.png";
import Analytics from "../../extras/Analytics";
import { useNavigate } from "react-router-dom";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import CancelBookingDialog from "./CancelBookingDialog";
import CancleDetails from "./CancleDetails";
import { permissionError } from "../../../util/Alert";
import CompleteBookingDetails from "./CompleteBookingDialog";
import Button from "../../extras/Button";
import { getAllSalons, getSalonDetail } from "../../../redux/slice/salonSlice";
import { getAllExpert } from "../../../redux/slice/expertSlice";
import ReactDatePicker from "react-datepicker";
import { allUsers, getUser } from "../../../redux/slice/userSlice";
import dayjs from "dayjs";
import AppointMentDialogue from "../appointment/AppointMentDialogue";
import LazyImage from "../../extras/ImageFallback";

const Booking = () => {
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const { booking, total } = useSelector((state) => state.booking);
  const { setting } = useSelector((state) => state.setting);
  const { salon, salonDetail } = useSelector((state) => state.salon);
  const { expert } = useSelector((state) => state.expert);
  const { user } = useSelector((state) => state?.user);
  const { userProfile } = useSelector((state) => state?.user);

  const dispatch = useDispatch();
  const [selectedSalon, setSelectedSalon] = useState("ALL");
  const [selectedExpert, setSelectedExpert] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [data, setData] = useState([]);
  const [type, setType] = useState("ALL");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  const [search, setSearch] = useState("");
  const today = new Date();
  const [startTime, setStartTime] = useState(new Date());
  const [date, setDate] = useState(today);

  const [error, setError] = useState({
    name: "",
    categoryy: "",
    image: "",
    imagePath: "",
    duration: "",
    // price: "",
    salon: "",
  });
  const navigate = useNavigate();
  const payload = {
    start: page,
    limit: rowsPerPage,
    type,
    startDate,
    endDate,
  };

  useEffect(() => {
    const payload = {
      start: 0,
      limit: 50,
      search: "ALL",
    };
    dispatch(getAllSalons(payload));
  }, [dispatch]);

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      search,
      salonId: selectedSalon,
    };
    dispatch(getAllExpert(payload));
    dispatch(getAllSalons(payload));
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      search,
    };
    dispatch(allUsers(payload));
  }, [dispatch, page, rowsPerPage, search]);

  useEffect(() => {
    dispatch(getAllBookings({ ...payload, command: true }));
  }, [page, rowsPerPage, type, startDate, endDate]);

  useEffect(() => {
    setData(booking);
  }, [booking]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleInfo = (id) => {
    navigate("/admin/expert/getExpertProfile", {
      state: {
        id,
      },
    });
  };

  const handleUserInfo = (id) => {
    navigate("/admin/user/userProfile", {
      state: {
        id,
      },
    });
  };

  const bookingTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "User",
      Cell: ({ row }) => (
        <div
          className="userProfile cursor"

        >
          <LazyImage
            src={row?.user?.image}
            alt="image"
            // onClick={() => handleUserInfo(row?.user?._id)}
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            onError={(e) => {
              e.target.src = male;
            }}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
          onClick={() => handleUserInfo(row?.user?._id)}
        >
          {row?.user?.fname
            ? row?.user?.fname + " " + row?.user?.lname
            : "Salon User"}
        </span>
      ),
    },
    {
      Header: "Expert",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
          onClick={() => handleInfo(row?.expert?._id)}
        >
          {row?.expert?.fullName}
        </span>
      ),
    },
    {
      Header: "Salon",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  "
        >
          {row?.salon?.name}
        </span>
      ),
    },
    {
      Header: "Service",
      Cell: ({ row }) => (
        <div>
          {row?.services?.map((dur, index) => (
            <span key={index} className="text-capitalize">
              {dur?.name}
              {index !== row?.services?.length - 1 && <br />}
            </span>
          ))}
        </div>
      ),
    },
    {
      Header: "Booking Id",
      body: "bookingId",
    },
    {
      Header: `Price `,
      body: "amount",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.amount?.toFixed(2) + " " + (setting?.currencySymbol || "$")}
        </span>
      ),
      sorting: { type: "client" },
    },
    {
      Header: `Admin Commission`,
      body: "platformFee",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.status == "cancel"
            ? "-"
            : row?.platformFee?.toFixed(2) + " " + (setting?.currencySymbol || "$")}
        </span>
      ),
    },
    {
      Header: "Duration",
      body: "duration",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.duration + " " + "Min"}</span>
      ),
    },
    {
      Header: "Date",
      body: "date",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.date ? row?.date : "-"}</span>
      ),
    },

    {
      Header: "Start time",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.time ? row?.time[0] : "-"}
        </span>
      ),
    },
    {
      Header: "Status",
      Cell: ({ row }) =>
        row?.status === "completed" ? (
          <button
            className="badge badge-success p-2"
            onClick={() => handleCompleteOpenDialogue(row)}
          >
            Completed
          </button>
        ) : row?.status === "confirm" ? (
          <button className="badge badge-primary p-2 ">
            Confirm
          </button>
        ) : row?.status === "cancel" ? (
          <button
            className="badge badge-danger p-2"

            onClick={() => handleOpenDialogue(row)}
          >
            Cancel
          </button>
        ) : (
          <span>
            <button
              className="badge badge-warning p-2"

              onClick={() => handleCancel(row._id)}
            >
              Pending
            </button>
          </span>
        ),
    },
  ];

  const handleCancel = (row) => {
    dispatch(openDialog({ type: "cancelBooking", data: row }));
  };

  const bookingType = [
    // { name: "ALL", value: "ALL" },
    { name: "Pending", value: "pending" },
    { name: "Confirm", value: "confirm" },
    { name: "Completed", value: "completed" },
    { name: "Cancelled", value: "cancel" },
  ];

  const handleOpenDialogue = (row) => {
    dispatch(openDialog({ type: "cancel", data: row }));
  };
  const handleCompleteOpenDialogue = (row) => {
    dispatch(openDialog({ type: "complete", data: row }));
  };

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
  };

  const handleTimeChange = (time) => {
    setStartTime(time);
  };

  const removeUser = (file) => {
    setSelectedUser(null);
  };

  // const handleOpenAppointment = () => {
  //   dispatch(openDialog({ type: "appointment" }));
  // };

  return (
    <>
      <div className="userPage">
        <div className="d-flex justify-content-end mb-3">
          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
        </div>
        <div className="user-table mb-3">
          <div className="user-table-top">
            <div className=" d-flex justify-content-between align-items-center w-100 ">
              <div className="w-100">
                <h5
                  className="main-title">
                  Bookings
                </h5>
              </div>
              <div className="d-flex gap-2 justify-content-end w-100">
                <div className="inputData w-25 ">

                  <select
                    name="bookingType"
                    className="form-select "
                    id="bookingType"
                    value={type}
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                  >
                    <option value="ALL" selected>
                      All
                    </option>
                    {bookingType?.map((data) => {
                      return <option value={data?.value}>{data?.name}</option>;
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <Table
            data={data}
            mapData={bookingTable}
            serverPerPage={rowsPerPage}
            serverSearching={handleFilterData}
            type={"server"}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>



      </div>

      {dialogue && dialogueType === "cancelBooking" && (
        <CancelBookingDialog setData={setData} data={data} />
      )}
      {dialogue && dialogueType === "cancel" && (
        <CancleDetails setData={setData} data={data} />
      )}
      {dialogue && dialogueType === "complete" && (
        <CompleteBookingDetails setData={setData} data={data} />
      )}
    </>
  );
};
export default Booking;
